import ng_en_GB from '@angular/common/locales/en';
import ng_fr_FR from '@angular/common/locales/fr';
import { fr_FR, en_GB } from 'ng-zorro-antd/i18n';
import { ICwtCoreConfig } from '@cawita/core-front';
import * as models from '@shared/models';
import { environment } from '../../environments/environment';
import { CwtDefaultAuthConfig } from '@cawita/core-front/auth';

export const CwtUserCoreConfig: ICwtCoreConfig = {
    api: {
        apiUrl: environment.apiUrl,
        models: Object.values(models) as any[],
    },
    asset: {
        assetUrl: environment.assetUrl,
        protectedAssetPath: environment.protectedAssetPath,
        publicAssetPath: environment.publicAssetPath,
    },
    auth: {
        stateStorageKey: 'cwt-kaarlo-user-auth',
        api: {
            ...CwtDefaultAuthConfig?.api,
            registerEndpoint: '/as-customer/customer'
        },
        navigation: {
            defaultRoute: ['/'],
            permissionDeniedRoute: ['/'],
            loginRoute: ['/'],
        },
    },
    i18n: {
        currentLocaleStorageKey: 'cwt-user-locale',
        defaultCurrencyCode: 'EUR',
        defaultLocale: 'fr',
        locales: [
            { localeId: 'fr', localeName: 'Français', ngLocaleData: ng_fr_FR, extra: { nzLocaleData: fr_FR } },
            { localeId: 'en', localeName: 'English', ngLocaleData: ng_en_GB, extra: { nzLocaleData: en_GB } },
        ],
        resources: [
            { prefix: '/assets/i18n/', suffix: '.json' },
            { prefix: '/assets/i18n/', suffix: '.errors.json', key: 'errors' },
            { prefix: '/assets/i18n/', suffix: '.countries.json', key: 'countries' },
        ]
    }
}